import React from 'react';


export default function PageContainer({ children, className = '' }) {
    return (
        <div className={`page-container-layout ${className}`}>
            {children}
        </div>
    );
}
